
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Item } from '../../modal/item.interface';
import { Order } from '../../modal/order.interface';
import { User } from '../../modal/user.interface';
import * as moment from 'moment';
import { UserService } from '../user/user.service';
import { LinkTableService } from '../link-document-table/link-table.service';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  avistaDesconto = 0.95;
  avistaDescontoDesc = '5%';
  avistaDescontoDefault = 0.95;
  avistaDescontoDescDefault = '5%';

  constructor(
    private httpClient: HttpClient,
    private linkTable: LinkTableService,
    private messageService: MessageService,
    ) {}

  async gerarPdf(items: Item[], order: Order, user: User) {
    this.avistaDesconto = order.desconto
      ? order.desconto
      : this.avistaDescontoDefault;
    this.avistaDescontoDesc = order.descontoDesc
      ? order.descontoDesc
      : this.avistaDescontoDescDefault;

    let product = [];
    let cpfCnpj = '';
    let rgIe = '';
    let latest_date = moment(order?.dateCreate).format('DD/MM/yyyy HH:mm');
    product = items;
    let userData = user || {};
    /*
    if (user!.email == 'dev@dgsys.com.br' || user!.email == 'eukryss@gmail.com' || user?.email == 'andi_07@hotmail.com') {
      userData = await (new Promise((resolve) => {
        this.userServ.getUserByIdObservable(order?.uidUserOrdered!).subscribe((data) => {
          resolve(data);
        });
      }))
    }
    */

    if (order!.user) {
      if ((order!.user!.personType = 'pj')) {
        cpfCnpj = 'CNPJ: ' + order!.user!.cnpj;
      } else {
        cpfCnpj = 'CPF: ' + order!.user!.cnpj;
      }
      if ((order!.user!.personType = 'pj')) {
        rgIe = 'IE: ' + order!.user!.inscricao;
      } else {
        rgIe = 'Rg: ' + order!.user!.inscricao;
      }
    } else {
      if ((userData!.personType = 'pj')) {
        cpfCnpj = 'CNPJ: ' + userData!.cnpj;
      } else {
        cpfCnpj = 'CPF: ' + userData!.cnpj;
      }
      if ((userData!.personType = 'pj')) {
        rgIe = 'IE: ' + userData!.inscricao;
      } else {
        rgIe = 'Rg: ' + userData!.inscricao;
      }
    }

    /*
// (00) 00000-0000
const maskPhone = value => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{4})(\d)/, "$1-$2");
};
    */
    const html: {
      name: string;
      html: string;
      headerHTML: string;
      footerHTML: string;
    } = {
      name: this.getFileName(order, user),
      html: `
        ${user?.uid ? `
        <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; margin-top: 50px'>
        <tr style="width: 90%;">
          <th style="width: 70%;">
          <h3 style="font-size: 16px; text-align: left; margin-left: 15px">${
            order?.user ? order?.user.displayName : userData?.displayName
          }<h3>
          <h3 style="font-size: 11px; text-align: left; margin-top: -15px; margin-left: 15px">Email: ${
            order?.user
              ? order?.user.emailContato
                ? order?.user.emailContato
                : order?.user.email
              : userData?.email
          }</h3>
          </th>
          <th style="width: 30%;">
          <h3 style="font-size: 22px; text-align: left; margin-left: 15px">Tabela Preço: ${order?.region!}<h3>
          </th>
        </tr>
      </table>
      <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; margin-top: -13px'>
        <tr style="width: 90%;">
          <th style="width: 60%;">
            <h3 style="font-size: 11px; text-align: left; margin-left: 15px">Telefone 1: ${
              order?.user && order?.user.phoneNumber ? order?.user.phoneNumber : userData?.phoneNumber
            }<h3>
            <h3 style="font-size: 11px; text-align: left; margin-top: -14px; margin-left: 15px">Telefone 2: ${
              order?.user && order?.user.phoneNumber2 ? order?.user.phoneNumber2 : ''
            }<h3>
            <h3 style="font-size: 11px; text-align: left; margin-top: -10px; margin-left: 15px">${cpfCnpj}</h3>
            <h3 style="font-size: 11px; text-align: left; margin-top: -10px; margin-left: 15px">${rgIe}</h3>
          </th>
        </tr>
        ${
          order?.code 
          ? `<tr style="width: 90%;">
              <th style="width: 60%;">
                <h3 style="font-size: 12px; text-align: left; margin-left: 15px">Vendedor: ${order?.seller}</h3>
              </th>
            </tr>`
          : ''
        }
      </table>
      <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; margin-top: 0px'>
        <tr style="width: 90%;">
          <th style="width: 60%;">
          <h3 style="font-size: 14px; text-align: left; margin-left: 15px">${
            order?.user ? order?.user.logradouro : userData?.logradouro
          } - ${
      order?.user ? order?.user.numero : userData?.numero
    } - Bairro: ${order?.user ? order?.user.bairro : userData?.bairro}<h3>
          <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px">CEP: ${
            order?.user
              ? (order?.user.cep + '')
                  .replace(/\D/g, '')
                  .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
              : (userData?.cep + '')
                  .replace(/\D/g, '')
                  .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
          }</h3>
          </th>
          <th style="width: 40%;">
          <h3 style="font-size: 14px; text-align: left; margin-left: 15px">${
            order?.user ? order?.user.cidade : userData?.cidade
          }<h3>
          <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px">ESTADO: ${
            order?.user ? order?.user.estado : userData?.estado
          }</h3>
          </th>
        </tr>
      </table>
        ` : ''}`,
      headerHTML: `
    <table style='width: 100%; webkit-print-color-adjust: exact;color:#000 !important; margin-top: 5px'>
      <tr>
          <td style="width: 80%;">
              <h3 style="font-size: 19px; margin-top: -1px; text-align: center"><img alt="logo" width="120" height="50"
              src="data:image/png;base64,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"><h3>
              ${
                order?.code 
                ? `<h3 style="font-size: 11px; text-align: center; margin-top: -15px">Pedido: ${order?.code}</h3>`
                : `<h3 style="font-size: 11px; text-align: center; margin-top: -15px">Resumo da Compra</h3>`
              }
              <h3 style="font-size: 9px; text-align: center; margin-top: -13px">Data: ${latest_date}</h3>
      </tr>
    </table>
    `,
      footerHTML: btoa(
        encodeURIComponent(`
      <style>
        .page-footer{
          -webkit-print-color-adjust: exact;
          color:#9c9a9a !important;
          font-size:8px !important;
          width: 100%;
          text-align: center;
        }
      </style>
      <span class='page-footer'>Desenvolvido por DG Sistemas</span>`)
      ),
    };
    if (
      order?.user ? order?.user.logradouroEntrega : userData?.logradouroEntrega
    ) {
      html.html += `
      <table  style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; margin-top: 0px'>
        <tr style="width: 90%;">
          <th style="width: 60%;">
            <h3 style="font-size: 12px; text-align: left; margin-left: 15px">ENDEREÇO DE ENTREGA<h3>
            <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">${
              order?.user
                ? order?.user.logradouroEntrega
                : userData?.logradouroEntrega
            } - ${
        order?.user ? order?.user.numeroEntrega : userData?.numeroEntrega
      } - Bairro: ${
        order?.user ? order?.user.bairroEntrega : userData?.bairroEntrega
      }<h3>
            <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px">CEP: ${
              order?.user
                ? (order?.user.cepEntrega + '')
                    .replace(/\D/g, '')
                    .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
                : (userData?.cepEntrega + '')
                    .replace(/\D/g, '')
                    .replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
            }</h3>
          </th>
          <th style="width: 40%;">
            <h3 style="font-size: 14px; text-align: left; margin-left: 15px">${
              order?.user ? order?.user.cidadeEntrega : userData?.cidadeEntrega
            }<h3>
            <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px">ESTADO: ${
              order?.user ? order?.user.estadoEntrega : userData?.estadoEntrega
            }</h3>
          </th>
        </tr>
      </table>`;
    }

    if (order!.observation) {
      html.html += `
      <table  style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; margin-top: 0px'>
        <tr style="width: 90%;">
        ${
          order?.code 
          ? `<th style="width: 100%;">
              <h3 style="font-size: 14px; text-align: left; margin-left: 15px">Observação<h3>
              <h3 style="font-size: 12px; text-align: left; margin-top: -15px; margin-left: 15px">${order!.observation}<h3>
            </th>`
          : ''
          }
        </tr>
      </table>`;
    }
    html.html += `<table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
                    <tr style="width: 90%">
                      <th style="width: 60%;">Nome</th>
                      <th style="width: 20%;">Quantidade</th>
                      <th style="width: 20%;">Cor</th>
                      <th style="width: 20%;">Preço Unitário</th>
                      <th style="width: 20%;">Preço</th>
                    </tr>`;
    for (let i = 0; i < product.length; i++) {

      if (!product[i].regiao[order?.region!].valorAtual)
      product[i].regiao[order?.region!].valorAtual = product[i].regiao[order?.region!].preco;

    let valueProd = null;
    let prodPromo = this.getProdPromo(product[i], order);
    let totalProductValue = 0;

      if (prodPromo) {
        valueProd = (+this.round(
          product[i].regiao[order?.region!].preco * (product[i].kit ? 0.97 : 1)
        )).toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
        totalProductValue = +(this.round(product[i].regiao[order?.region!].preco * (product[i].kit ? 0.97 : 1)) * product[i].amount);
      } else if (product[i].kit) {
        valueProd = (+this.round(
          product[i].regiao[order?.region!].valorAtual
        )).toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
        totalProductValue = (+this.round(product[i].regiao[order?.region!].preco) * product[i].amount);
      }

      let prodValue = (
        +this.round(
          product[i].regiao[order?.region!].valorAtual * (product[i].kit ? 0.97 : 1)
        ) * product[i].amount!
      ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      let prodUnitValue = (+this.round(
        product[i].regiao[order?.region!].valorAtual * (product[i].kit ? 0.97 : 1)
      )).toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
      });

      html.html += `
          <tr style="border: 1px solid black;">
            <td style="width: 60%; text-align: center; border: 1px solid black;">
                <h3 style="font-size: 14px; text-align: left; margin-left: 15px">
                ${product[i].codigo} - ${product[i].descricao}
                <h3>

          `;
      if (product[i].observation) {
        html.html += `<h3 style="font-size: 11px; text-align: left; margin-top: -19px; margin-left: 15px">Observação produto: ${product[i].observation}</h3>`;
      }
      if (product[i].kit) {
        html.html += `
              <h3 style="font-size: 9px; text-align: left; margin-top: -8px; margin-left: 15px">Quantidade de caixas: ${product[i].kit_amount}</h3>`;
      }
      if (product[i].codigoBarra) {
        html.html += `
            <h3 style="font-size: 9px; text-align: left; margin-top: -8px; margin-left: 15px">Código de barras: ${
              product[i].corSelecionada && product[i].cores[product[i].corSelecionada[0].cor] ? product[i].cores[product[i].corSelecionada[0].cor].barra : product[i].cores[Object.keys(product[i].cores)[0]].barra
            || ''}</h3>`
      }
      if (product[i].corVariada && product[i].coresQtd.length > 1) {
        html.html += `
            <hr>
            <h3 style="font-size: 9px; text-align: left; margin-top: -8px; margin-left: 15px">Detalhes de cores</h3> <br>`;

        for (let p = 0; p < product[i].coresQtd.length; p++) {
          const element = product[i].coresQtd[p];

          html.html += `
          <h3 style="font-size: 9px; text-align: left; margin-top: -8px; margin-left: 15px"><b>Cor</b>: ${element.corDescricao.toUpperCase()} | Qtd.: ${element.qtd || 0}</h3>`;
        }

        html.html += `
        <hr>`;

      } 
      html.html += `  
            <h3 style="font-size: 9px; text-align: left; margin-top: -8px; margin-left: 15px">NCM: ${
              product[i].ncm
            }</h3>
          </td>
          <td style="width: 20%; text-align: center; border: 1px solid black;">${
            product[i].amount
          }</td>
          <td style="min-width: 100px; text-align: center; border: 1px solid black;">
          ${
            (product[i]?.cores && this.upper(product[i]?.cores[this.getColorKey(product[i].cores)]?.corDescricao)) ?? ''
          }
          </td>
          <td style="min-width: 100px; text-align: center; border: 1px solid black;">`;
          
          if (prodPromo || product[i].kit) {
            html.html += `
            <span style="text-decoration: line-through;">${valueProd}</span><br>
            `;
          }
          
          html.html += `
          <span>${prodUnitValue}</span><br>
          </td>
          <td style="min-width: 100px; text-align: center; border: 1px solid black;">
        `;

        if (prodPromo || product[i].kit) {
          html.html += `
            <span style="text-decoration: line-through;">${ totalProductValue.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
            </span><br>
          `;
        }
        html.html += `
          ${prodValue}
          </td>
        </tr>
        `;
    }

    let value = (order?.totalPrice!).toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });
    let totalValue = (order?.totalPrice! + order?.valorFrete!).toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });
    let valorFrete = order?.valorFrete!.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
    });

    let cnpj = undefined;
    if (order!.user) {
      if ((order!.user!.personType = 'pj')) {
        cnpj = order!.user!.cnpj;
      }
    } else {
      if ((userData!.personType = 'pj')) {
        cnpj = userData!.cnpj;
      }
    }
    let tabelaEspecial = this.linkTable.specialDocuments.map(doc => doc.document).includes(cnpj);

    if (order!.totalPrice! <= 5000 || tabelaEspecial) {
      if (order.valorFrete) {
        html.html += `
                <tr style="background-color:  rgb(242, 248, 242);" >
                  <td style="width: 60%; text-align: center;">
                      <h3 style="font-size: 14px; text-align: left; margin-left: 15px"><h3>
                      <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px"></h3>
                  </td>
                  <td></td>
                  <td style="width: 20%; text-align: center">
                    <h3 style="font-size: 13px; text-align: left; margin-top: 10px; margin-left: 15px">VALOR</h3>
                  </td>
                  <td></td>
                  <td style="width: 20%; text-align: center">${value}</td>
                </tr>`;

        html.html += `
                <tr style="background-color:  rgb(242, 248, 242);" >
                  <td style="width: 60%; text-align: center;">
                      <h3 style="font-size: 14px; text-align: left; margin-left: 15px"><h3>
                      <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px"></h3>
                  </td>
                  <td></td>
                  <td style="width: 20%; text-align: center">
                    <h3 style="font-size: 13px; text-align: left; margin-top: 10px; margin-left: 15px">FRETE</h3>
                  </td>
                  <td></td>
                  <td style="width: 20%; text-align: center">${valorFrete}</td>
                </tr>`;
      }

      html.html += `
              <tr style="background-color:  rgb(242, 248, 242);" >
                <td style="width: 60%; text-align: center;">
                    <h3 style="font-size: 14px; text-align: left; margin-left: 15px"><h3>
                    <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px"></h3>
                </td>
                <td></td>
                <td style="width: 20%; text-align: center">
                  <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Valor <h3>
                  <h3 style="font-size: 14px; text-align: left; margin-top: -17px; margin-left: 15px">TOTAL</h3>
                </td>
                <td></td>
                <td style="width: 20%; text-align: center">${totalValue}</td>
              </tr>`;
    } else {
      let totalValueDiscount = ((
        order!.totalPrice! > 5000 && order!.totalPrice! < 7500
          ? order!.totalPrice! * 0.985
          : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
          ? order!.totalPrice! * 0.97
          : order!.totalPrice! > 10000
          ? order!.totalPrice! * 0.95
          : order!.totalPrice!
      ) + order?.valorFrete!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      let percentDiscount =
        order!.totalPrice! > 5000 && order!.totalPrice! < 7500
          ? '1,5%'
          : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
          ? '3%'
          : order!.totalPrice! > 10000
          ? '5%'
          : '';
      html.html += `
        <tr style="background-color:  rgb(242, 248, 242);" >
          <td style="width: 60%; text-align: center;">
              <h3 style="font-size: 14px; text-align: left; margin-left: 15px"><h3>
              <h3 style="font-size: 9px; text-align: left; margin-top: -15px; margin-left: 15px"></h3>
          </td>
          <td></td>
          <td style="width: 20%; text-align: center">
            <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Valor <h3>
            <h3 style="font-size: 14px; text-align: left; margin-top: -17px; margin-left: 15px">TOTAL</h3>
            <h3 style="font-size: 10px; text-align: left; margin-top: -17px; margin-left: 15px">Desconto de ${percentDiscount}<h3>
          </td>
          <td></td>
          <td style="width: 20%;">
            <span style="width: 20%; text-align: center; font-size: 11px; text-decoration: line-through">${totalValue}</span><br>
            <span style="width: 20%; text-align: center">${totalValueDiscount}</span>
          </td>

        </tr>`;
    }


    /*
    let { totalPricePaid, totalValue2, descTotalInCash, descPerValue, descDetailPayment } = this.getValues(order, order.paymentMethod, order.paymentDay);
    html.html += `<table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>`
    if (order.valorFrete) {
      html.html += `
      <tr>
        <td colspan="3"  class="text-right"><b>Valor:
          ${order.totalPrice! > 5000 && order.totalPrice! < 7500 ? ' (1,5% Desconto):' : ''}
          ${order.totalPrice! > 7500 && order.totalPrice! < 10000? ' (3% Desconto):' : ''}
          ${order.totalPrice! > 10000 ? ' (5% Desconto):' : ''}</b></td>
        <td class="text-center">
          <s *ngIf="!checkUserCNPJEspecial() && order.totalPrice! > 5000">{{order.totalPrice! | currency: 'BRL'}}</s>
          <br *ngIf="!checkUserCNPJEspecial() && order.totalPrice! > 5000">
          ${tabelaEspecial ? '' : ((order.totalPrice! > 5000 && order.totalPrice! < 7500) ? (order.totalPrice! * 0.985) :
            ((order.totalPrice! > 7500 && order.totalPrice! < 10000) ? (order.totalPrice! * 0.97) :
            ((order.totalPrice! > 10000) ? (order.totalPrice! * 0.95) : order.totalPrice!))).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="text-right"><b>Frete:</b></td>    
        <td class="text-center">{{order.valorFrete | currency: 'BRL' }}</td>      
      </tr>      
      `;
    }

    html.html += `
      <tr>
        <td colspan="3" class="text-right"><b>Valor total${descPerValue}: </b></td>
        <td class="text-center">
          <s *ngIf="!checkUserCNPJEspecial() && order.totalPrice! > 5000">${order.totalPrice.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</s>
          <br *ngIf="!checkUserCNPJEspecial() && order.totalPrice! > 5000">
          ${totalValue2.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </td>
      </tr>
    
      `;

      if (order!.paymentMethod == 'PIX' || order!.paymentMethod == 'BOLETO') {

        html.html += `
        <tr>
          <td colspan="3" class="text-right" *ngIf="descTotalInCash"><b>${descTotalInCash}:</b></td>
          <td class="text-center">
            <span style="white-space: pre-line">${descDetailPayment}</span>
            <span *ngIf="totalPricePaid">${totalPricePaid ? totalPricePaid.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : ''}</span>
            
          </td>
        </tr>
        `;
      }
      
    html.html += `</table>`;


      */

    if (order!.paymentMethod == 'PIX') {

      let totalValue = (order!.totalPrice!!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

      if (tabelaEspecial) {
        html.html += `
        <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
           <tr style="background-color: rgb(242, 248, 242);" >
             <td style="width: 60%; text-align: center;">
                 <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                 <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">PIX</h3>
             </td>
             <td></td>

             <td style="width: 20%; text-align: center">
             </td>
             <td style="width: 20%; text-align: center">${totalValue}</td>
           </tr>`;
      } else {
        
        let totalValue = ((
          (order!.totalPrice! > 5000 && order!.totalPrice! < 7500
            ? order!.totalPrice! * 0.985
            : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
            ? order!.totalPrice! * 0.97
            : order!.totalPrice! > 10000
            ? order!.totalPrice! * 0.95
            : order!.totalPrice!) * this.avistaDesconto
        ) + order?.valorFrete!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

        html.html += `
          <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
             <tr style="background-color: rgb(242, 248, 242);" >
               <td style="width: 60%; text-align: center;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">PIX</h3>
               </td>
               <td></td>
  
               <td style="width: 20%; text-align: center">
               <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Desconto de <h3>
               <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">${this.avistaDescontoDesc} à vista</h3>
               </td>
               <td style="width: 20%; text-align: center">${totalValue}</td>
             </tr>`;
      }
    } else {
      if (order?.paymentMethod!.indexOf('Cartão de Crédito') > -1) {
        let totalValue = (
          (order?.totalPrice! + order?.valorFrete!) / order?.installment!
        ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
        html.html += `
        <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
           <tr style="background-color: rgb(242, 248, 242);" >
             <td style="width: 60%; text-align: center;">
                 <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                 <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">${order.paymentMethod}</h3>
             </td>
             <td></td>

             <td style="width: 20%; text-align: center">
             <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcelas <h3>
             <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">${order.installment}x</h3>
             </td>
             <td style="width: 20%; text-align: center">${totalValue}</td>
           </tr>`;
      } else {
        if (order.paymentMethod == 'BOLETO') {
          if (order.paymentDay == '7') {
            let totalValue = ((
              (order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) * this.avistaDesconto
            ) + order?.valorFrete!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
              <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
                 <tr style="background-color: rgb(242, 248, 242);" >
                   <td style="width: 60%; text-align: center;">
                       <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                       <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (Até 7 dias)</h3>
                   </td>
                   <td></td>

                   <td style="width: 20%; text-align: center">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Desconto de <h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">${this.avistaDescontoDesc} à vista</h3>
                   </td>
                   <td style="width: 20%; text-align: center">${totalValue}</td>
                 </tr>`;
          }

          if (order.paymentDay == '14') {
            let data = this.getDate(14);
            let totalValue = ((
              order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!
            ) + order?.valorFrete!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
              <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
               <tr style="background-color: rgb(242, 248, 242);" >
               <td style="width: 60%; text-align: center;">
                 <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                 <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (Até 14 dias)</h3>
                </td>
                <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                    <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 1 / 1<h3>
                    <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '30') {
            let data = this.getDate(30);
            let totalValue = ((
              order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!
            ) + order?.valorFrete!).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
            <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
               <tr style="background-color: rgb(242, 248, 242);" >
               <td style="width: 60%; text-align: center;">
                 <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                 <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (Até 30 dias)</h3>
                </td>
                <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                    <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 1 / 1<h3>
                    <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '14/21/28') {
            let data = this.getDate(14);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
            <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                    <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                    <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (14/21/28)</h3>
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 1 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '14/21/28') {
            let data = this.getDate(21);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 2 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '14/21/28') {
            let data = this.getDate(28);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 3 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '28/35/42') {
            let data = this.getDate(28);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
            <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                  <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                  <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (28/35/42)</h3>
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 1 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '28/35/42') {
            let data = this.getDate(35);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 2 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '28/35/42') {
            let data = this.getDate(42);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 3 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '30/45/60') {
            let data = this.getDate(30);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
            <table style='width: 100%; webkit-print-color-adjust: exact; color:#000 !important; border: 1px solid black; border-collapse: collapse;'>
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                  <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Forma de pagamento: <h3>
                  <h3 style="font-size: 14px; text-align: left; margin-top: -15px; margin-left: 15px">BOLETO (30/45/60)</h3>
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 1 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }

          if (order.paymentDay == '30/45/60') {
            let data = this.getDate(45);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 2 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }
          if (order.paymentDay == '30/45/60') {
            let data = this.getDate(60);
            let totalValue = (
              ((order!.totalPrice! > 5000 && order!.totalPrice! < 7500
                ? order!.totalPrice! * 0.985
                : order!.totalPrice! > 7500 && order!.totalPrice! < 10000
                ? order!.totalPrice! * 0.97
                : order!.totalPrice! > 10000
                ? order!.totalPrice! * 0.95
                : order!.totalPrice!) + order?.valorFrete!) / 3
            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

            html.html += `
               <tr style="background-color: rgb(242, 248, 242);" >
                 <td style="width: 60%; text-align: center;">
                 </td>
                 <td></td>

                 <td style="width: 20%; text-align: center; font-size: 11px;">
                   <h3 style="font-size: 9px; text-align: left; margin-left: 15px; margin-top: 5px">Parcela 3 / 3<h3>
                   <h3 style="font-size: 14px; text-align: left; margin-top: -10px; margin-left: 15px">${data}</h3>
                 </td>
                 <td style="width: 20%; text-align: center">R$ ${totalValue} </td>
               </tr>`;
          }
        }
      }

      html.html += '</table>';
    }

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    html.html = btoa(encodeURIComponent(html.html));
    html.headerHTML = btoa(encodeURIComponent(html.headerHTML));

    const pdf = (await this.httpClient
      .post(
        `https://urfz04e4m5.execute-api.us-east-1.amazonaws.com/dev/getPDF?isMobile=true`,
        html,
        {
          headers,
        }
      )
      .toPromise()) as any;
    window.open(pdf.url);
  }

  getDate(days: number) {
    return moment().add(days, 'd').format('DD/MM/YYYY');
  }

  private getColorKey(item: any) {
    return Object.keys(item)[0];
  }

  private upper(value: string): string {

    if(!value) {
      return '';
    }

    return value.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  public calcFrete(valor: number, regiao: string) {
    if (valor >= 750 && valor <= 1150) {
      switch (regiao) {
        case 'R1': return 135;
        case 'R2': return 190;
        case 'R3': return 210;
        default:
          break;
      }
    } else {
      if (valor >= 1150 && valor <= 1550) {
        switch (regiao) {
          case 'R1': return 115;
          case 'R2': return 160;
          case 'R3': return 190;      
          default:
            break;
        }
      } else {
        if (valor >= 1550 && valor < 2500) {
          switch (regiao) {
            case 'R1': return 95;
            case 'R2': return 130;
            case 'R3': return 160;      
            default:
              break;
          }
        }      
      }
    }
    return 0;
  }

  round(number:number) {
    return Math.round(number * 100) / 100;  
  }

  private getProdPromo(prod: Item, order: Order) {
    return  prod.regiao[order?.region!].valorAtual !== prod.regiao[order?.region!].preco;
  }
  
  getValues(order: Order, paymentMethod: string, paymentDay: string) {
    let totalPricePaid = undefined;
    let descDetailPayment = '';
    let descTotalInCash = '';
    let totalValue = 0;
    let descPerValue = '';


    if (!order.cnpjEspecial) {
      totalValue = this.geTotalValue(order);

      switch (paymentMethod) {
        case 'PIX': { // OK
          totalPricePaid = this.getInCashValue(order);
          totalValue = this.geTotalValue(order);
          descPerValue = this.getDescPerValue(order);
          descTotalInCash = `Valor total à vista (Pix ${this.avistaDescontoDesc} Desconto)`;

          break;
        }
          

        case 'BOLETO': {
          switch (paymentDay) {
            case '7': { // OK
              totalPricePaid = this.getInCashValue(order);
              
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Valor total (Até 7 dias no boleto - ${this.avistaDescontoDesc} Desconto)`;
    
              break;
            }
            case '14': {
              /* Cenários: 
              1 - Tabela não especial. Valor abaixo de R$5.000 - OK
              2 - Tabela não especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              3 - Tabela não especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              4 - Tabela não especial. Valor acima de R$10.000 - OK
              */
              totalPricePaid = this.geTotalValue(order);
              totalValue = this.geTotalValue(order);
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(14);
    
              break;
            }
            case '30': {
              /* Cenários: 
              1 - Tabela não especial. Valor abaixo de R$5.000 - OK
              2 - Tabela não especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              3 - Tabela não especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              4 - Tabela não especial. Valor acima de R$10.000 - OK
              */
              totalPricePaid = this.geTotalValue(order);
              totalValue = this.geTotalValue(order);
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(30);
    
              break;
            }
            case '14/21/28': {
              /* Cenários: 
              1 - Tabela não especial. Valor abaixo de R$5.000 - OK
              2 - Tabela não especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              3 - Tabela não especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              4 - Tabela não especial. Valor acima de R$10.000 - OK
              */
              let totalPricePaid = this.geTotalValue(order);
              totalValue = this.geTotalValue(order);
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(14);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(21);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(28);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
    
              break;
            }
            case '28/35/42': {
              /* Cenários: 
              1 - Tabela não especial. Valor abaixo de R$5.000 - OK
              2 - Tabela não especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              3 - Tabela não especial. Valor abaixo de R$10.000 e maior que R$ 7.500
              4 - Tabela não especial. Valor acima de R$10.000
              */
              let totalPricePaid = this.geTotalValue(order);
              totalValue = this.geTotalValue(order);
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(28);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(35);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(42);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
    
              break;
            }
            case '30/45/60': {
              /* Cenários: 
              1 - Tabela não especial. Valor abaixo de R$5.000 - OK
              2 - Tabela não especial. Valor abaixo de R$7.500 e maior que R$ 5.000
              3 - Tabela não especial. Valor abaixo de R$10.000 e maior que R$ 7.500
              4 - Tabela não especial. Valor acima de R$10.000
              */
              let totalPricePaid = this.geTotalValue(order);
              totalValue = this.geTotalValue(order);
              descPerValue = this.getDescPerValue(order);
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(30);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(45);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(60);
              descDetailPayment += ` ${(totalPricePaid / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
    
              break;
            }
          
            default:
              break;
          }
          
          
          break;
        }      
        default:
          break;
      }

    } else {
      totalValue = order.totalPrice;
      
      switch (paymentMethod) {
        case 'BOLETO': {
          switch (paymentDay) {
            case '7': { 
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500
              8 - Tabela especial. Valor acima de R$10.000
              */
              totalPricePaid = order.totalPrice;
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(7);
              break
            }
            case '14': { 
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000 
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              8 - Tabela especial. Valor acima de R$10.000 - OK
              */
              totalPricePaid = order.totalPrice;
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(14);
              break
            }
            case '30': { 
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              8 - Tabela especial. Valor acima de R$10.000 - OK
              */
              totalPricePaid = order.totalPrice;
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(30);
              descTotalInCash = `Opção de pagamento Boleto`;
              break
            }
            
            case '14/21/28': {
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000 - OK
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000 - OK
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500 - OK
              8 - Tabela especial. Valor acima de R$10.000 - OK
              */
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(14);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(21);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(28);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              break
            }
            
            case '28/35/42': {
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000 - OK
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500
              8 - Tabela especial. Valor acima de R$10.000
              */
              descTotalInCash = `Opção de pagamento Boleto`;
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(28);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(35);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(42);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              break
            }
            
            case '30/45/60': {
              /* Cenários:               
              5 - Tabela especial. Valor abaixo de R$5.000 - OK
              6 - Tabela especial. Valor abaixo de R$7.500 e maior que R$ 5.000
              7 - Tabela especial. Valor abaixo de R$10.000 e maior que R$ 7.500
              8 - Tabela especial. Valor acima de R$10.000
              */
              descTotalInCash = `Opção de pagamento Boleto`;
              descDetailPayment = this.getDate(30);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(45);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              descDetailPayment += `\n` + this.getDate(60);
              descDetailPayment += ` ${(totalValue / 3).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
              break
            }
            
            default:
              break;
          }
        }
      }
    }


    return { 
      totalPricePaid: totalPricePaid, 
      totalValue2: totalValue, 
      descTotalInCash: descTotalInCash, 
      descPerValue: descPerValue, 
      descDetailPayment: descDetailPayment };
  }

  geTotalValue(order: Order) {
    let value = (order.totalPrice! > 5000 && order.totalPrice! < 7500) ? (order.totalPrice! * 0.985) :
                  ((order.totalPrice! > 7500 && order.totalPrice! < 10000) ? (order.totalPrice! * 0.97) :
                  ((order.totalPrice! > 10000) ? (order.totalPrice! * 0.95) : order.totalPrice!));
    value += order.valorFrete;

    return value;
  }

  getInCashValue(order: Order) {
    let value = (order.totalPrice! > 5000 && order.totalPrice! < 7500) ? (order.totalPrice! * 0.985) :
                  ((order.totalPrice! > 7500 && order.totalPrice! < 10000) ? (order.totalPrice! * 0.97) :
                  ((order.totalPrice! > 10000) ? (order.totalPrice! * 0.95) : order.totalPrice!));
    value = value * this.avistaDesconto;
    value += order.valorFrete;

    return value;
  }

  getDescPerValue(order: Order) {
    if (order.totalPrice! > 5000 && order.totalPrice! < 7500) {
      return ` (1,5% Desconto)`;
    } else {
      if (order.totalPrice! > 7500 && order.totalPrice! < 10000) {
        return ` (3% Desconto)`;
      } else {
        if (order.totalPrice! > 10000) {
          return ` (5% Desconto)`;
        } else {
          return '';
        }
      }
    }
  }

  async getCities(state: string) {
    if (state.toString().length !== 2) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O estado deve ser informado utilizando a sigla correspondente (ex: SC).',
        life: 3000
      });
      throw new Error('O estado deve ser informado utilizando a sigla correspondente (ex: SC).');

    } else {
    return this.httpClient.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`).toPromise();
    }
  }
  
  async getStates() {
    return this.httpClient.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados`).toPromise();
  }

  private getFileName(order: Order, user: User) {
    if (order?.code) return `Pedido-${order?.code}`
    
    const date = new Date().getTime();
    return `Resumo da compra_${date}`;
  }

  public async getCodIBGEAndAdress(user: User) {
    if (user.cep && !user.cepEntrega) {
      let resp: any = await this.httpClient.get(`https://viacep.com.br/ws/${user.cep}/json/`).toPromise();
      if (resp.ibge) {
        user!.codIbge = resp.ibge;
        if (!user.addressFromGov) {
          user!.logradouro = resp.logradouro;
          user!.complemento = resp.complemento;
          user!.bairro = resp.bairro;
          user!.cidade = resp.localidade;
          user!.estado = resp.uf;
        }
      } else {
        if (resp.erro && !user.addressFromGov) {
          user!.codIbge = '';
          user!.logradouro = '';
          user!.complemento = '';
          user!.bairro = '';
          user!.cidade = '';
          user!.estado = '';
          user!.codIbge = '';

          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Endereço não encontrado a partir do CEP, informe manualmente.',
            life: 3000
          });
        }
      }
    }

    if (user.cepEntrega) {
      let resp: any = await this.httpClient.get(`https://viacep.com.br/ws/${user.cepEntrega}/json/`).toPromise();
      if (resp.ibge) {
        user!.codIbgeEntrega = resp.ibge;
        user!.logradouroEntrega = resp.logradouro;
        user!.complementoEntrega = resp.complemento;
        user!.bairroEntrega = resp.bairro;
        user!.cidadeEntrega = resp.localidade;
        user!.estadoEntrega = resp.uf;
      } else {
        if (resp.erro) {
          user!.codIbgeEntrega = '';
          user!.logradouroEntrega = '';
          user!.complementoEntrega = '';
          user!.bairroEntrega = '';
          user!.cidadeEntrega = '';
          user!.estadoEntrega = '';
          user!.codIbgeEntrega = '';

          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'Endereço de entrega não encontrado a partir do CEP, informe manualmente.',
            life: 3000
          });
        }
      }
    }
  }

  replaceSpecialChars(str: string): string {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]/gi,''); 
  }
}
